// extracted by mini-css-extract-plugin
module.exports = {"uploadBtn":"style_uploadBtn__19r0b"};